<template>
  <b-sidebar
    id="disable-switch-sidebar-right"
    right
    shadow
    no-header
    backdrop
    sidebar-class="sidebar-container"
    :visible="isDisableDripSwitchOpen"
    @hidden="onCancel"
  >
    <b-form @submit.prevent="submitForm" novalidate class="sidebar-form">
      <div class="sidebar-common">
        <div
          class="d-flex justify-content-end align-items-center color-wealthy-green-500 mb-4"
        >
          <div class="drip-body d-flex align-items-center" @click="onCancel">
            <b-icon-x scale="1.6" />
          </div>
        </div>
        <div class="drip-h2 font-weight-bold text-secondary">
          {{
            alternate
              ? $t('dashboard.disableDripSwitchSidebar.alternateTitle')
              : $t('dashboard.disableDripSwitchSidebar.title')
          }}
        </div>
        <h6
          class="drip-h3 font-weight-400 color-noble-blue-500 sidebar-subtitle"
        >
          {{
            alternate
              ? $t('dashboard.disableDripSwitchSidebar.alternateSubTitle')
              : $t('dashboard.disableDripSwitchSidebar.subTitle')
          }}
        </h6>
        <div>
          <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
            <b-form-checkbox
              v-for="option in options"
              v-model="selectedReason"
              :key="option.value"
              :value="option.value"
              :aria-describedby="ariaDescribedby"
              class="checkbox-group"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-group>
        </div>
        <label v-if="selectedReason.includes('Other')" class="mt-2">
          Other:
        </label>
        <input
          type="text"
          class="input-box"
          v-if="selectedReason.includes('Other')"
          placeholder="Please specify your reason"
          v-validate="'required'"
          data-vv-as="Reason"
          name="other-comment"
          v-model="othersInputValue"
        />
        <div class="error mt-1">
          {{ errors.first('other-comment') }}
        </div>
        <div class="error mt-1" v-if="errorMsg">
          {{ errorMsg }}
        </div>
        <div class="d-flex flex-column flex-md-row">
          <action-button
            size="small"
            variant="solid"
            type="submit"
            class="mb-3 font-weight-bold"
          >
            <b-icon-arrow-repeat
              v-if="isAPIFullFilled"
              animation="spin"
              class="mr-2 color-white"
            />
            {{
              alternate
                ? $t('dashboard.disableDripSwitchSidebar.alternateConfirmBtn')
                : $t('dashboard.enableDripSwitchModal.disableINR')
            }}
          </action-button>
          <action-button
            class="py-3 mb-3 modal-buttons"
            variant="text"
            :click="onCancelHandler"
          >
            {{ $t('dashboard.enableDripSwitchModal.cancel') }}
          </action-button>
        </div>
      </div>
    </b-form>
  </b-sidebar>
</template>
<script>
import invoiceService from '@/services/invoice'
import ActionButton from '@/components/common/ActionButton'

export default {
  components: {
    ActionButton
  },
  props: {
    alternate: Boolean,
    isDisableDripSwitchOpen: {
      type: Boolean,
      default: true
    },
    dataToSend: Object,
    onClose: Function,
    onCancel: Function,
    onSuccess: Function
  },
  data() {
    return {
      selectedReason: [],
      othersInputValue: '',
      sidebar: true,
      isAPIFullFilled: false,
      errorMsg: ''
    }
  },
  computed: {
    options() {
      return this.$t('dashboard.disableDripSwitchSidebar.options')
    }
  },
  methods: {
    submitForm() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.toggleDripSwitchStatus()
        }
      })
    },
    toggleDripSwitchStatus() {
      this.isAPIFullFilled = true
      const othersIndex = this.selectedReason.indexOf('Other')
      let selectedValues = [...this.selectedReason]
      if (this.selectedReason.length === 0) {
        this.isAPIFullFilled = false
        this.errorMsg = this.$t(
          'dashboard.disableDripSwitchSidebar.error.title'
        )
        return
      }
      if (othersIndex !== -1) {
        selectedValues[othersIndex] = this.othersInputValue
      }
      const screenLevel =
        this.$route.name === 'invoicesAdd' ? 'Invoice' : 'User'
      const mpData = {
        reason: selectedValues
      }
      if (this.$route.name === 'invoicesAdd') {
        mpData['invoiceId'] = this.dataToSend.invoice_id
      }
      this.$mpTrack(`Disable ${screenLevel} INR Confirmation`, mpData)
      return invoiceService
        .updateRemittanceStatus({
          ...this.dataToSend,
          comments: selectedValues
        })
        .then(({ status }) => {
          this.isAPIFullFilled = false
          if (status === 200) {
            this.onClose()
            this.onSuccess()
            this.othersInputValue = ''
            this.selectedReason = []
          } else {
            this.onCancel()
            this.$notify({
              title: this.$t('notifications.somethingWrong.title'),
              text: this.$t('notifications.somethingWrong.text'),
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.isAPIFullFilled = false
          return this.$notify({
            title: this.$t('notifications.somethingWrong.title'),
            text: this.$t('notifications.somethingWrong.text'),
            type: 'error'
          })
        })
    },
    onCancelHandler() {
      const screenLevel =
        this.$route.name === 'invoicesAdd' ? 'Invoice' : 'User'
      this.$mpTrack(
        `Disable Remittances Sidebar 'Cancel' button clicked at ${screenLevel} level`,
        this.$route.name === 'invoicesAdd'
          ? { invoiceId: this.dataToSend.invoice_id }
          : null
      )
      this.onCancel()
    }
  }
}
</script>
<style lang="scss">
.sidebar-container {
  width: 50%;
  @media screen and (max-width: $tablet) {
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
@import '../../assets/scss/variables';
@import '@/assets/scss/_palette.scss';
.sidebar-form {
  height: 100%;
}
.sidebar-common {
  background: $white;
  height: auto;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 32px;
  padding-bottom: 80px;
  font-family: $font-family-sans-serif;
  .heading {
    font-size: 36px;
    line-height: 42px;
  }
  .checkbox-group {
    font-size: 16px;
    margin-bottom: 24px;
    @media screen and (max-width: 768px) {
      margin-bottom: 12px;
    }
    .custom-control-label::before {
      border: 2px solid $wealthy-green-500;
    }
  }
  .checkbox-group:last-child {
    margin-bottom: 8px;
  }
  .sidebar-subtitle {
    margin-top: 16px;
    margin-bottom: 24px;
  }
  .modal-buttons {
    padding-left: 66px;
    padding-right: 66px;
    border-radius: 8px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }
  #submit-button {
    margin-right: 34px;
  }
  .input-box {
    width: 100%;
    padding: 0.6rem;
    border-radius: 0.5rem;
    border: none;
    outline: none;
    border: 1px solid map-get($noble-blue, 400);
  }
  .error {
    // TODO to use color from the palette
    color: $danger;
    font-size: 0.75rem;
    margin-bottom: 20px;
  }
}
</style>
